import { Controller } from '@hotwired/stimulus';

// Auto-submits the parent form when the input value changes.
//
// Usage:
//   <select data-controller="auto-submit"
//           data-action="change->auto-submit#submit">
export default class AutoSubmitController extends Controller {
  submit() {
    const form = this.element.closest('form');
    if (form) form.requestSubmit();
  }
}
